import { render, staticRenderFns } from "./OtpError.vue?vue&type=template&id=d00d59b0&scoped=true"
import script from "./OtpError.vue?vue&type=script&lang=js"
export * from "./OtpError.vue?vue&type=script&lang=js"
import style0 from "./OtpError.vue?vue&type=style&index=0&id=d00d59b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00d59b0",
  null
  
)

/* custom blocks */
import block0 from "./OtpError.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports